import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import Highlight from '../../../components/Highlight/Highlight';
import Background from '../../../components/Background/Background';
import generateGradientValue from '../generate-gradient-value';
import classes from './GradientCode.styles.less';
export default function GradientCode({ className, values, angle, type }) {
    const gradient = generateGradientValue({ values, angle, type });
    return (_jsxs(Background, { className: cx(classes.gradientCode, className), children: [_jsxs("div", { className: classes.section, children: [_jsx("div", { className: classes.title, children: "CSS" }), _jsx(Highlight, { children: `background-image: ${gradient};` })] }), _jsxs("div", { className: classes.section, children: [_jsx("div", { className: classes.title, children: "JavaScript" }), _jsx(Highlight, { children: `backgroundImage: '${gradient}',` })] })] }));
}
